// src/components/Backoffice/LicenseDashboard/SummaryCards.tsx

import React from 'react';

interface Props {
  total: number;
  regulares: number;
  pendentes: number;
  vencendo: number;
  vencidas: number;
  invalidas: number;
}

const SummaryCards: React.FC<Props> = ({
  total,
  regulares,
  pendentes,
  vencendo,
  vencidas,
  invalidas,
}) => {
  const cards = [
    {
      label: 'Total de documentos',
      value: total,
      color: 'text-blue-500',
    },
    {
      label: 'Regulares',
      value: regulares,
      color: 'text-green-500',
    },
    {
      label: 'Pendentes',
      value: pendentes,
      color: 'text-sky-600',
    },
    {
      label: 'Próximos do vencimento',
      value: vencendo,
      color: 'text-yellow-500',
    },
    {
      label: 'Vencidas',
      value: vencidas,
      color: 'text-red-500',
    },
    {
      label: 'Inválidos',
      value: invalidas,
      color: 'text-gray-700',
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-6">
      {cards.map((card) => (
        <div
          key={card.label}
          className="bg-white rounded-lg shadow p-4 border border-gray-200"
        >
          <p className="text-sm text-gray-500">
            {card.label}
          </p>

          <p className={`text-3xl font-bold mt-1 ${card.color}`}>
            {card.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
